import { forwardRef } from 'react';

import { Button, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

const ReadOnlyControl = styled(Flex)`
  height: 40px;
  padding: 10px 12px;
  padding-left: 0px;
  align-items: center;
  border-bottom: none;
`;

const UnderlinedControl = styled(Flex)`
  height: 40px;
  padding: 10px 12px;
  padding-left: 0px;
  align-items: center;
  border-bottom: 1px dashed ${(props) => props.theme.colors.text.g3};
  &:hover {
    border-bottom-style: solid;
  }
  &:focus-within,
  &[aria-expanded='true'] {
    border-bottom: 1px solid ${(props) => props.theme.colors.button.blue.default};
  }
`;

const UnderlinedButtonControl = styled(Button)`
  padding: 10px 12px;
  text-align: left;
  border: none;
  border-radius: 0;
  background: white;
  width: 100%;
  border-bottom: 1px dashed ${(props) => props.theme.colors.text.g3};
  &:hover,
  &[data-hover] {
    background: white;
    border-bottom-style: solid;
    box-shadow: none !important;
  }
  &:focus-within,
  &[aria-expanded='true'] {
    background: white;
    border-bottom: 1px solid ${(props) => props.theme.colors.button.blue.default};
  }
`;

export const ReadOnlyGenericControl = forwardRef((props, ref) => (
  <ReadOnlyControl ref={ref}>{props.children}</ReadOnlyControl>
));

export const GenericControl = forwardRef((props, ref) => {
  const EndIcon = props?.EndIcon;
  return (
    <UnderlinedControl tabIndex={0} ref={ref} {...props}>
      {props.children}
      {EndIcon ? <EndIcon /> : null}
    </UnderlinedControl>
  );
});

export const GenericControlAsButton = forwardRef((props, ref) => {
  const { EndIcon } = props;
  return (
    <UnderlinedButtonControl tabIndex={0} ref={ref} {...props}>
      {props.children}
      <EndIcon />
    </UnderlinedButtonControl>
  );
});
